module.exports = __webpack_public_path__ + "img/HQ-OA-360V04NGL_ALL.98e921aa.jpg";